import { createVuetify } from "vuetify";

import { de } from "vuetify/locale";
import {
	VBtn, VIcon, VBadge, VMenu, VTooltip, VDivider, VDialog, VSnackbar, VImg, VAvatar, VProgressCircular, VSheet,
	VContainer, VCol, VRow, VSpacer, 
	VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle,
	VList, VListGroup, VListItem, VListSubheader, VListItemAction, VListItemTitle, VListItemSubtitle, VExpansionPanels, VExpansionPanel, VExpansionPanelText, VExpansionPanelTitle,
	VTextField, VRadio, VRadioGroup, VCheckbox, VBtnToggle, VChip, VDatePicker, VAutocomplete, VTextarea, VInput, VSelect,
	VStepper, VStepperHeader, VStepperWindow, VStepperWindowItem, VStepperItem, VStepperActions, VEmptyState, VBanner,

} from "vuetify/components";
import { VDateInput } from "vuetify/labs/components";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";

export const vuetify = createVuetify({
	components: {
		VBtn, VIcon, VBadge, VMenu, VTooltip, VDivider, VDialog, VSnackbar, VImg, VAvatar, VProgressCircular, VSheet,
		VContainer, VCol, VRow, VSpacer, 
		VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle,
		VList, VListGroup, VListItem, VListSubheader, VListItemAction, VListItemTitle, VListItemSubtitle, VExpansionPanels, VExpansionPanel, VExpansionPanelText, VExpansionPanelTitle,
		VTextField, VRadio, VRadioGroup, VCheckbox, VBtnToggle, VChip, VDatePicker, VAutocomplete, VTextarea, VInput, VSelect,
		VStepper, VStepperHeader, VStepperItem, VStepperWindow, VStepperWindowItem, VStepperActions, VEmptyState, VBanner,
		VDateInput,
	},
	locale: {
		locale: "de",
		messages: { de },
	},
	icons: {
		defaultSet: "mdi",
		aliases,
		sets: {
			mdi,
		},
	},
	theme: {
		defaultTheme: "light",
		variations: false,
		themes: {
			light: {
				dark: false,
				colors: {
					primary: "#f49500",
					"on-primary": "#ffffff",
					secondary: "#30141d",
					accent: "#f49500",
					"on-accent": "#ffffff",
					grey: "#9E9E9E",
				}
			}
		}
	}
});
